import React from "react";
import styles from "./DpScheduledPatientInfo.module.scss";
import {AmbulanceNewIcon, FemaleIcon} from "../../../assets";
import {InfoText} from "../../../shared";
import moment from "moment/moment";

const DpDestinations = ({d, index}) => {
  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        {/*<FemaleIcon className='mr-5'/>*/}
        <div className={styles.title} >Адрес {index + 1}</div>
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'Дата прибытия'} text={`${moment(d?.arrival_date).format('DD/MM/YYYY')}`}/>
        <InfoText className={styles.dcText} title={'Время прибытия'} text={d?.time}/>
        <InfoText className={styles.dcTextComplaints} title={'Город'} text={d?.city}/>

        {/*<InfoText className={styles.dcText} title={'Ожидание на месте'} text={d?.waiting_time}/>*/}
      </div>
      <div className={styles.wrapper}>
        {d?.station_info && <InfoText className={styles.dcTextComplaints} title={'Название стационара'} text={d?.station_info}/>}
         <InfoText className={styles.dcTextComplaints} title={'Адрес'} text={d?.address}/>
      </div>
      {d?.infoText && <div className={styles.wrapper}>
        <InfoText className={styles.dcTextComplaints} title={'Доп. информация'} text={d?.infoText}/>
      </div>}
    </div>
  </div>
}

export default DpDestinations
